var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('diary-list',{attrs:{"diaryList":_vm.diaryList}})],1),_c('common-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }